<template>
  <div class="historyComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex class="text-sm-right" xs2 sm2>
            <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="startDate" :rules="rules.required" :error-messages="errors.start_date" :label="$t('general.startDate')" v-on="on" required prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="startDate" :max="finishDate" @input="menu3 = false" color="primary" :locale="$t('history.local')"></v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="text-sm-right" xs2 sm2>
           <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="finishDate" :rules="rules.required" :error-messages="errors.end_date" :label="$t('general.endDate')" v-on="on" required prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="finishDate" @input="menu4 = false" :max="new Date().toISOString().substr(0, 10)" :min="startDate" :locale="$t('history.local')" color="primary"></v-date-picker>
            </v-menu>
        </v-flex>
        <v-btn color="primary" icon @click="send()">
          <v-icon>search</v-icon>
        </v-btn>
        <v-flex class="text-xs-right">
          <v-dialog
            persistent
            v-model="dialog"
            max-width="700px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                <v-icon left>filter_list</v-icon>
                {{$t('general.filter')}}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{$t('general.filter')}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form
                  lazy-validation
                  ref="form"
                  v-model="valid"
                  >
                    <v-layout>
                      <v-flex xs6>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              required
                              :rules="rules.required"
                              :error-messages="errors.start_date"
                              v-model="startDate"
                              :label="$t('general.startDate')"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :max="finishDate"
                            color="primary"
                            v-model="startDate"
                            @input="menu = false"
                            :locale="$t('history.local')"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6>
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              required
                              :rules="rules.required"
                              v-model="finishDate"
                              :error-messages="errors.end_date"
                              :label="$t('general.endDate')"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="finishDate"
                            @input="menu2 = false"
                            :max="new Date().toISOString().substr(0, 10)"
                            :min="startDate"
                            :locale="$t('history.local')"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <v-switch
                          color="primary"
                          v-model="switchAllCategories"
                          :label="switchAllCategories ? $t('history.allCategories') : $t('history.perCategorie')"
                        ></v-switch>
                        <v-select
                          :rules="rules.required"
                          :items="categories"
                          item-text="name"
                          item-value="id"
                          v-model="selectedCategory"
                          v-if="!switchAllCategories"
                          :label="$t('general.categories')"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <v-switch
                          color="primary"
                          :label="switchAllProjects ? $t('history.allProjects') : $t('history.perProject')"
                          v-model="switchAllProjects"
                        >
                        </v-switch>
                        <v-select
                          v-if="!switchAllProjects"
                          clearable
                          :items="projects"
                          v-model="selectedProject"
                          :label="$t('general.projects')"
                          item-value="id"
                          item-text="name"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <v-switch
                          color="primary"
                          v-model="switchAllStatus"
                          :label="switchAllStatus ? $t('history.allStatus') : $t('history.perStatus')"
                        ></v-switch>
                        <v-select
                          :rules="rules.required"
                          :items="status"
                          item-text="name"
                          item-value="id"
                          v-model="selectedStatus"
                          :label="$t('general.status')"
                          v-if="!switchAllStatus"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ $t('expenses.' + data.item.name)}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ $t('expenses.' + data.item.name)}}
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{$t('general.close')}}
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  round
                  depressed
                  @click="send"
                >
                  {{$t('general.submit')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table
        class="elevation-2"
        :headers="headers"
        :items="expenses"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
        :expand="expand"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="grey lighten-3" @click="props.expanded = !props.expanded">
          <td class="d-flex align-center" width="70px"><v-icon small>mdi-chevron-down</v-icon><div class="ml-2">{{ props.item.id }}</div></td>
          <td class="text-sm-center">{{props.item.description}}</td>
          <td class="text-sm-center">{{props.item.project.name}}</td>
          <td class="text-sm-center">{{ props.item.start_date }} / {{ props.item.end_date }}</td>
          <td class="text-sm-center">{{$t('expenses.' + props.item.status_expense.name)}}</td>
          <td class="text-sm-center">{{ calcularTotalGeneral(props.item.items) }}</td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-layout>
            <v-flex xs12>
              <h2 class="primary--text text-sm-left ml-3 mt-2">{{$t('general.expenseItems')}}:</h2>
            </v-flex>
          </v-layout>
          <v-layout v-if="props.item.items.length === 0">
            <v-flex xs12>
              <p class="text-sm-left ml-4">{{$t('history.noItem')}}</p>
            </v-flex>
          </v-layout>
          <v-layout v-if="props.item.items.length !== 0">
            <v-flex xs12>
              <table width="100%">
                <thead>
                  <th class="text-sm-center font-weight-black">#</th>
                  <th class="text-sm-center font-weight-black">{{$t('general.description')}}</th>
                  <th class="text-sm-center font-weight-black">{{$t('general.subtotal')}}</th>
                  <th class="text-sm-center font-weight-black">{{$t('general.total')}}</th>
                  <th class="text-sm-center font-weight-black">{{$t('general.comment')}}</th>
                  <th class="text-sm-center font-weight-black">{{$t('general.actions')}}</th>
                </thead>
                <tbody v-for="item of props.item.items" :key="item.id">
                  <tr v-if="item.has_multiprojects && item.isTitle" style="background-color: lightblue; height: 30px">
                    <td colspan="7"><b>{{item.titleName}}</b></td>
                  </tr>
                  <tr :class="{'custom-row-color': item.gst_receipt_types_id === 4}">
                    <td class="text-sm-center">{{item.id}}</td>
                    <td class="text-sm-center">{{item.description}}</td>
                    <td class="text-sm-center">{{item.subtotal | formatCurrency}}</td>
                    <td class="text-sm-center">{{item.total | formatCurrency}}</td>
                    <td class="text-sm-center">{{item.comment}}</td>
                    <td v-if="item.gst_receipt_types_id !== 4" class="text-sm-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="attachFiles(item)" small icon outline color="primary" v-on="on">
                            <v-icon small>attach_file</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.attachedFiles') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item.receipt_type.id === 2 || item.receipt_type.id === 3">
                        <template v-slot:activator="{ on }">
                          <v-btn small icon outline color="primary" v-on="on" @click="showModal(item, props.item)">
                            <v-icon small>remove_red_eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item !== null && item.receipt_type.id !== 2 && item.receipt_type.id !== 3">
                        <template v-slot:activator="{ on }">
                          <v-btn  @click="viewItemsF(item)" small icon outline color="primary" v-on="on">
                          <v-icon small>remove_red_eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                    </td>
                    <td v-else></td>
                </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-card>
      </template>
      </v-data-table>
        <v-flex class="text-xs-right">
          <v-dialog
            v-model="dialogF"
            scrollable
            max-width="900px"
            persistent>
            <v-card v-if="receipt_type === 1">
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItemF.id }} <span> ( {{editedItemF.receipt_type.name ? editedItemF.receipt_type.name : ''}} )</span></h2>
                <v-spacer />
                <v-btn
                  :disabled="!cfdiHtml"
                  round
                  flat
                  color="primary"
                  @click="sendToPrint()"
                  ><v-icon left>print</v-icon> {{ $t('general.print') }}</v-btn>
                  <v-flex class="text-right">
                        <v-btn small icon color="error" @click="close" class="ml-5">
                        <v-icon small>clear</v-icon>
                      </v-btn>
                  </v-flex>
              </v-toolbar>
              <v-card-text class="text-center" v-if="!cfdiHtml">
                <v-progress-circular class="my-5" indeterminate size="70" color="primary" />
              </v-card-text>
              <v-card-text v-else>
                <iframe
                  name="cfdi"
                  :srcdoc="cfdiHtml"
                  style="width:845px; height:1200px; border:0">
                </iframe>
                <v-container grid-list-md>
                  <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.category')"
                          disabled
                          outline
                          :value="editedItemF.gst_categories.name ? editedItemF.gst_categories.name : ''">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.comment')"
                          disabled
                          outline
                          v-model="editedItemF.comment">
                        </v-textarea>
                      </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  flat
                  round
                  class="white--text"
                  depressed
                  @click="close">
                  {{$t('general.cancel')}}
                </v-btn>
                <v-btn
                  color="success darken-1"
                  round
                  flat
                  :loading="loadingXML"
                  @click="downloadXML"
                >
                  {{$t('general.downloadXML')}}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else>
            <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItemF.id }}
              <span>
                (
                {{
                  editedItemF.receipt_type ? editedItemF.receipt_type.name : ''
                }}
                )</span
              >
            </h2>
            <v-btn class="marginLeft" v-if="editedItemF.gst_receipt_types_id === 3 && applyFeatures" round flat color="primary" @click="showEditCategory">
              <v-icon left>list</v-icon> {{ titleTagCategory }}
            </v-btn>
            <v-flex class="text-right">
              <v-btn small icon color="error" @click="close" class="ml-5">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
            </v-toolbar>
            <v-card-text v-if="!editCategory">
              <v-form lazy-validation ref="form" v-model="valid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                    <v-flex xs12>
                        <v-text-field
                          :label="$t('general.date')"
                          :value="expenseItem.date"
                          disabled
                          prepend-icon="event"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.country')"
                          :value="expenseItem.country.descripcion"
                          disabled
                          prepend-icon="location_on"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6 v-if="expenseItem.gst_categories.id !== null">
                        <v-select
                          disabled
                          required
                          :items="categories"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :label="$t('categories.name')"
                          prepend-icon="list"
                          :value="expenseItem.gst_categories.id"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex v-if="hasMultiProjects && expenseItem.project_id && expenseItem.project_id > 0" xs12 md12>
                        <v-text-field :label="$t('general.project')" :value="projectName(expenseItem)" disabled prepend-icon="list"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.description')"
                          disabled
                          prepend-icon="forum"
                          :value="expenseItem.description"
                        >
                        </v-textarea>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.currency')"
                          disabled
                          prepend-icon="paid"
                          :value="expenseItem.currency.descripcion"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.exchangeRate')"
                          disabled
                          prepend-icon="currency_exchange"
                          :value="expenseItem.exchange"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6 v-if="expenseItem.gst_receipt_types_id === 3">
                        <v-text-field
                          :label="$t('general.supplier')"
                          disabled
                          prepend-icon="store"
                          :value="expenseItem.vendor.name"
                        >
                        </v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 md6 v-if="expenseItem.gst_receipt_types_id === 3">
                        <v-text-field
                          :label="$t('general.iva')"
                          disabled
                          prepend-icon="percent"
                          :value="expenseItem.foreign_tax.percent"
                        >
                        </v-text-field>
                      </v-flex> -->
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.subtotal')"
                          disabled
                          prepend-icon="attach_money"
                          :value="expenseItem.subtotal"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.total')"
                          disabled
                          prepend-icon="attach_money"
                          :value="expenseItem.total"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex  xs12 md6>
                        <v-text-field :value="expenseItem.sat_forma_pago.descripcion" v-if="expenseItem.sat_forma_pago != null" :label="$t('general.formaPago')" disabled prepend-icon="credit_card">
                        </v-text-field>
                        <v-text-field v-else :label="$t('general.formaPago')" disabled prepend-icon="credit_card"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.folioRef')"
                          disabled
                          prepend-icon="article"
                          :value="expenseItem.folio"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.comment')"
                          disabled
                          prepend-icon="3p"
                          :value="expenseItem.comment"
                        >
                        </v-textarea>
                      </v-flex>
                    </v-flex>
                    <v-flex xs6 layout v-if="dataURL">
                      <v-flex xs12>
                        <a v-if="!isPDF(dataURL)" @click="openPDF()">
                          <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                        </a>
                        <iframe
                              v-if="isPDF(dataURL)"
                              :src="dataURL"
                              frameborder="0"
                              width="100%"
                              height="400px"
                            ></iframe>
                        <v-btn
                          block
                          v-if="isPDF(dataURL)"
                          @click="openPDF()"
                          color="primary"
                          depressed
                        >
                          <v-icon left>insert_drive_file</v-icon>
                          {{ $t('expenseItems.watchFile') }}
                        </v-btn>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-text v-if="editCategory">
                  <v-layout>
                    <v-flex md12>
                      <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                      <v-layout>
                          <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="editedItemF.item_lines"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                            <template v-slot:items="props">
                              <tr>
                                <td class="text-sm-left text-truncate" style="width: 40%">
                                  <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                                </td>
                                <td style="width: 20%">
                                  <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                                </td>
                                <td style="width: 30%" class="text-sm-center">
                                  <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]" :items="categories"  color="primary" />
                                </td>
                                <td style="width: 10%">
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                      <v-btn :disabled="true" @click="editConceptsCategory(props.item, props.index)" small icon outline color="primary" v-on="on">
                                        <v-icon small>edit</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>{{ $t('general.edit') }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                flat
                round
                class="white--text"
                depressed
                @click="close"
              >
                {{ $t('general.close') }}
              </v-btn>
            </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'historyComponent',
  data () {
    return {
      userLogged: {},
      editItemCategories: {},
      receipt_type: '',
      showPrevious: true,
      showNext: true,
      titleTagCategory: this.$t('general.category'),
      concepts: [],
      editCategory: false,
      tagMoneda: '',
      settings: {},
      currencySetting: {},
      menu: false,
      startDate: new Date().toISOString().substr(0, 8) + '01',
      menu2: false,
      errors: {},
      finishDate: new Date().toISOString().substr(0, 10),
      expand: false,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15,
        totalItems: 0
      },
      dialog: false,
      itemDialog: false,
      loadingXML: false,
      dataURL: null,
      switchAllCategories: true,
      switchAllStatus: true,
      switchAllProjects: true,
      selectedCategory: null,
      selectedStatus: null,
      selectedProject: null,
      valid: true,
      expenses: [],
      expenseItem: {
        gst_categories: {
          name: ''
        },
        country: {
          descripcion: ''
        },
        currency: {
          descripcion: '',
          c_Moneda: ''
        },
        sat_forma_pago: {
          descripcion: ''
        }
      },
      loading: false,
      loadingItems: true,
      categories: [],
      projects: [],
      status: [],
      url: '',
      dialogF: false,
      editedItemF: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: ''
        },
        sat_metodo_pago: {},
        validator_comment: '',
        item_lines: []
      },
      cfdiHtml: null,
      expenseId: 0,
      menu3: false,
      menu4: false
    }
  },
  computed: {
    hasMultiProjects () {
      if (this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      return false
    },
    applyFeatures () {
      if (this.$store.state.userLogged.company === undefined) {
        return false
      }

      if (this.$store.state.userLogged.company[0].features.find(x => x.name === 'EXPENSE_LINES')) {
        return true
      }

      return false
    },
    heading () {
      return this.$t('history.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-history fa-fw icon-color'
    },
    conceptsHeader () {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true
        },
        {
          text: this.$t('general.period'),
          align: 'center',
          value: 'period',
          sortable: true
        },
        {
          text: this.$t('general.status'),
          align: 'center',
          value: 'status',
          sortable: true
        },
        {
          text: `${this.$t('general.amount')} ${this.tagMoneda}`,
          align: 'center',
          value: 'amount',
          sortable: true
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    settings () {
      this.filterCurrency()
    },
    dialog (val) {
      val || this.close()
    },
    '$store.state.userLogged' () {
      this.initialize()
    },
    switchAllProjects () {
      if (this.switchAllProjects) {
        this.selectedProject = null
      }
    },
    switchAllCategories () {
      if (this.switchAllCategories) {
        this.selectedCategory = null
      }
    },
    switchAllStatus () {
      if (this.switchAllStatus) {
        this.selectedStatus = null
      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    calcularTotalGeneral (items) {
      let total = 0
      for (let i = 0; i < items.length; i++) {
        if (items[i].total) {
          total += parseFloat(items[i].total)
        }
      }
      return total.toFixed(2)
    },
    filterCurrency () {
      const foundCurrencySetting = this.settings.find(x => x.setting_type.name === 'st.currency' && x.company_id === this.$store.state.userLogged.company[0].id)
      this.currencySetting = foundCurrencySetting || { value: { c_Moneda: 'MXN' } }
      this.tagMoneda = this.currencySetting.value.c_Moneda
      this.editedItemF.currency = this.currencySetting.value
      // this.defaultItem.currency = this.currencySetting.value
    },
    resetCategories () {
      this.editCategory = false
      this.titleTagCategory = this.$t('general.category')
      this.editItemCategories = {}
    },
    showEditCategory () {
      this.editedItemF.item_lines = this.expenseItem.item_lines
      // this.concepts = JSON.parse(JSON.stringify(this.editedItemF.item_lines))
      // this.concepts.forEach(item => { item.editCategory = false })
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense')
    },
    downloadXML () {
      this.loadingXML = true
      this.$store.dispatch('downloadXML', {
        event: {
          context: this,
          fileId: this.editedItemF.gst_expenses_items_files[0].files_id,
          description: this.editedItemF.description
        }
      })
    },
    projectName (item) {
      return item.gst_expenses.multiprojects.find(x => x.id === item.project_id).name
    },
    showModal (item) {
      this.dataURL = null
      this.cfdiHtml = null
      this.itemDialog = true
      this.receipt_type = 2
      this.editedItemF = item
      this.itemExpenseDialog(item.id)
      this.dialogF = true
      if (item.gst_receipt_types_id === 2 || item.gst_receipt_types_id === 3) {
        if (
          item.gst_expenses_items_files !== undefined &&
          item.gst_expenses_items_files !== null
        ) {
          if (item.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: item.gst_expenses_items_files[0].files_id
              }
            })
          }
        }
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    close () { // close the dialog and re-assing default values
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.loading = false
      this.dialogF = false
      // this.$refs.form.resetValidation()
      this.resetCategories()
      this.cfdiHtml = null
    },
    isPDF (data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF () {
      var tab = window.open()
      tab.document.write('<body style="margin: 0;"> <iframe src="' + this.dataURL + '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>')
    },
    closeItem () {
      this.expenseItem = {
        gst_categories: {
          name: ''
        },
        country: {
          descripcion: ''
        },
        currency: {
          descripcion: ''
        },
        sat_forma_pago: {
          descripcion: ''
        }
      }
      this.itemDialog = false
      this.loading = false
      this.dataURL = null
    },
    itemExpenseDialog (item) {
      this.loading = true
      this.$emit('getExpenseItem', {id: item, context: this})
    },
    showExpenseItemFile () {
      if (this.expenseItem.gst_receipt_types_id === 2) {
        if (this.expenseItem.gst_expenses_items_files !== undefined && this.expenseItem.gst_expenses_items_files !== null) {
          if (this.expenseItem.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: this.expenseItem.gst_expenses_items_files[0].files_id
              }
            })
          }
        }
      }
    },
    send () { // evaluate the form and save de values
      if (this.$refs.form.validate()) {
        this.getReport()
      }
    },
    getReport () {
      this.loadingItems = true
      if (this.$store.state.userLogged.company) {
        this.$emit('send', {
          id: this.userLogged.id,
          start: this.startDate,
          end: this.finishDate,
          category_id: this.selectedCategory,
          project_id: this.selectedProject,
          status_id: this.selectedStatus,
          type: 'json',
          context: this
        })
      }
    },
    initialize () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.$emit('send', {id: this.userLogged.id, start: this.startDate, end: this.finishDate, context: this})
        this.$emit('get', {company_id: this.$store.state.userLogged.company[0].id, context: this})
      }
      // this.$emit('getLogged', {context: this})
    },
    dateFormat (date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    viewItemsF (items) {
      if (items.gst_receipt_types_id === 1) {
        this.dialogF = true
        this.viewItemsFs(items)
      }
    },
    viewItemsFs (items) {
      this.receipt_type = 1
      if (items.gst_expenses_items_files.length > 0) {
        this.editedItemF = items
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: items.gst_expenses_items_files[0].files_id,
            context: this,
            type: 'viewItemsF'
          }
        })
      }
      items.views = true
    },
    attachFiles (item) {
      this.$router.push('/expenses/files/watch/' + item.id)
    }
  }
}
</script>

<style lang="css" scoped>
  .custom-row-color {
      background-color:rgba(137, 119, 240, 0.322);
  }
</style>



// WEBPACK FOOTER //
// src/components/history.component.vue